import { HeaderItemCard } from "@/components/Common/Card";

interface Props {
  budgetAmount: number;
  basisAmount?: number;
  sumPurchaseAmount: number;
  sumSalesAmount: number;
}

export function ProjectEstimateHeader({
  budgetAmount,
  basisAmount,
  sumPurchaseAmount,
  sumSalesAmount,
}: Props) {
  return (
    <div className="grid grid-cols-3 gap-x-5">
      <HeaderItemCard
        title={basisAmount ? "기초 금액" : "배정 예산"}
        value={`${(basisAmount || budgetAmount).toLocaleString()}원`}
      />
      <HeaderItemCard
        title="매입가 총 합계 (부가세 포함)"
        value={`${sumPurchaseAmount.toLocaleString()}원`}
      />
      <HeaderItemCard
        title="판매가 총 합계 (부가세 포함)"
        value={`${sumSalesAmount.toLocaleString()}원`}
      />
    </div>
  );
}
